/**
 * ResponsavelBlock — vendedor responsavel pelo lead.
 *
 * Select alimentado por `useResponsaveisCrm` (GET /api/crm/responsaveis,
 * so `lead:view`). A selecao comeca no responsavel ATUAL do lead — nunca no
 * usuario logado: com o select vazio (403 do antigo /api/usuarios) o botao
 * "Atribuir" ficava ativo e atribuia o lead a quem clicava (CRM-22). So salva
 * ao clicar "Atribuir" — evita PATCH a cada mudanca de select.
 */
import React, { useEffect, useMemo, useState } from "react";

import Block from "../../../components/Block";
import AsyncButton from "../../../components/AsyncButton";
import useResponsaveisCrm from "../../../hooks/useResponsaveisCrm";
import { Field, FieldValue, Select } from "../../Orcamentos/styles";

function ResponsavelBlock({ lead, onAtribuir, podeEditar }) {
  const { responsaveis } = useResponsaveisCrm({ enabled: Boolean(podeEditar) });
  const [selecionado, setSelecionado] = useState(() => lead.responsavel || "");

  useEffect(() => {
    setSelecionado(lead.responsavel || "");
  }, [lead.responsavel]);

  // O responsavel atual pode ter sido desativado: continua visivel no
  // select (com o nome do lead) para a pessoa entender o que esta trocando.
  const opcoes = useMemo(() => {
    const lista = [...responsaveis];
    const atual = lead.responsavel ? String(lead.responsavel) : "";
    if (atual && !lista.some((u) => String(u.id) === atual)) {
      lista.unshift({ id: atual, nome: lead.responsavel_nome || "Responsável atual" });
    }
    return lista;
  }, [responsaveis, lead.responsavel, lead.responsavel_nome]);

  const mudou = useMemo(
    () => String(selecionado || "") !== String(lead.responsavel || ""),
    [selecionado, lead.responsavel]
  );

  const atribuir = async () => {
    await onAtribuir(selecionado || null);
  };

  if (!podeEditar) {
    return (
      <Block title="Responsável">
        <FieldValue>{lead.responsavel_nome || "Sem responsável"}</FieldValue>
      </Block>
    );
  }

  return (
    <Block title="Responsável">
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        <Field>
          Vendedor
          <Select
            aria-label="Vendedor responsável"
            value={selecionado || ""}
            onChange={(e) => setSelecionado(e.target.value)}
          >
            <option value="">— Sem responsável —</option>
            {opcoes.map((u) => (
              <option key={u.id} value={u.id}>
                {u.nome}
              </option>
            ))}
          </Select>
        </Field>
        <AsyncButton
          variant="secondary"
          onClick={atribuir}
          successMessage="Responsável atualizado."
          silentError
          disabled={!mudou}
          style={{ alignSelf: "flex-start" }}
        >
          Atribuir
        </AsyncButton>
      </div>
    </Block>
  );
}

export default ResponsavelBlock;
